import { type HTMLAttributes, type ReactNode, type Ref } from 'react'
import { TableRow } from '@/components/Table'
import { ClickableTableCellElementContext } from '@/components/Table/ClickableTable'
import { type VirtuosoContext } from '@/components/VirtualTableInfiniteScrollLoaderContainer'

interface VirtualStripedTableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  children?: ReactNode
  'data-index': number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Virtuoso passes the context of whichever table renders the row.
  context?: VirtuosoContext<any>
  ref?: Ref<HTMLTableRowElement>
}

/**
 * Virtual Striped Table Row
 * Uses the index as specified by the Virtuoso component to conditionally render
 * the row props.
 */
export function VirtualStripedTableRow({
  ref,
  context,
  children,
  ...props
}: VirtualStripedTableRowProps) {
  const item: unknown = context?.scroller.items[props['data-index']]
  const onPressItem = context?.onPressItemRow
  const onPressItemRow =
    onPressItem && item ? () => onPressItem(item) : undefined

  return (
    <TableRow
      ref={ref}
      odd={props['data-index'] % 2 !== 0}
      onClick={onPressItemRow}
      {...props}
    >
      <ClickableTableCellElementContext value="td">
        {children}
      </ClickableTableCellElementContext>
    </TableRow>
  )
}
